module.exports = __webpack_public_path__ + "media/images/850/narcolepsy_moon_mountains-dbdcd133e97bc85ad40ab925ff8c68bc.webp";